import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=97d5cf1a&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=97d5cf1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d5cf1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97d5cf1a')) {
      api.createRecord('97d5cf1a', component.options)
    } else {
      api.reload('97d5cf1a', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=97d5cf1a&scoped=true&", function () {
      api.rerender('97d5cf1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XcaIOsIYVng0/JS/comp/Voucher.vue"
export default component.exports